// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3TZ4J","errors":"Errors_errors__2aIKP"};